<template>
  <div>
    <VToolbar flat>
      <VToolbarTitle>
        <div>
          <span>Meni</span>
        </div>
      </VToolbarTitle>
    </VToolbar>
    <VDivider style="flex: 0" />
    <div class="drawer_content_container">
      <v-list dense>
        <template v-for="item in items">
          <v-layout v-if="item.heading" :key="item.heading" row align-center>
            <v-flex xs6>
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-flex>
            <v-flex xs6 class="text-xs-center">
              <a href="#!" class="body-2 black--text">EDIT</a>
            </v-flex>
          </v-layout>
          <v-list-group
            v-else-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon=""
          >
            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ item.text }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-for="(child, i) in item.children" :key="i">
              <v-list-tile-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ child.text }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>
          <v-list-tile v-else :key="item.text" :to="item.route">
            <v-list-tile-action>
              <v-icon color="primary">
                {{ item.icon }}
              </v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.text }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'SettingsListTile',
  data() {
    return {
      items: [
        {
          icon: 'dashboard',
          text: 'Splošne nastavitve',
          route: '/settings/general',
        },
        {
          icon: 'trending_up',
          text: 'Šifrant partnerjev',
          route: '/settings/partners',
        },
        {
          icon: 'forward',
          text: 'Šifrant izdajateljev',
          route: '/settings/document-issuers',
        },
        {
          icon: 'account_balance',
          text: 'IBAN šifrant',
          route: '/settings/partner-iban',
        },
        {
          icon: 'email',
          text: 'Šifrant email naslovov',
          route: '/settings/email-mapping',
        },
        {
          icon: 'euro_symbol',
          text: 'Šifrant valut',
          route: '/settings/currencies',
        },
        {
          icon: 'payments',
          text: 'Šifrant načinov plačila',
          route: '/settings/payment-type',
        },
        {
          icon: 'public',
          text: 'Šifrant držav',
          route: '/settings/countries',
        },
      ],
    };
  },
  computed: {
    ...mapGetters(['drawerOpened']),
  },
};
</script>

<style scoped></style>
